import { render } from "./layout-box.vue?vue&type=template&id=81313a96&scoped=true"
import script from "./layout-box.vue?vue&type=script&lang=js"
export * from "./layout-box.vue?vue&type=script&lang=js"

import "./layout-box.vue?vue&type=style&index=0&id=81313a96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81313a96"]])

export default __exports__